/**
 * Phase 9 — sets <html lang> whenever `language` changes.
 * StrictMode-safe: no cleanup restoration. Every V2 page sets the value
 * on mount, so navigation between V2 routes always shows the correct
 * language. Leaving V2 for a legacy route is not restored here — legacy
 * pages remain in the last V2 language until a real browser navigation,
 * which is acceptable for a SPA moving between distinct surfaces.
 */
import { useEffect } from 'react';

export default function useDocumentLanguage(language) {
  useEffect(() => {
    const target = language === 'es' ? 'es' : 'en';
    if (document.documentElement.lang !== target) {
      document.documentElement.lang = target;
    }
  }, [language]);
}
